"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.swrConfiguration = exports.postFetcher = exports.getPublicFetcher = exports.getFetcher = exports.Http = exports.apiVersion = void 0;
const axios_1 = __importDefault(require("axios"));
const Mock_1 = require("../api/Mock");
const utils_1 = require("../common/utils");
const useMock = false;
// process.env.NODE_ENV === 'development'
exports.apiVersion = 'v1';
const token = '';
const Http = axios_1.default.create({
    baseURL: '/api',
    withCredentials: false,
    headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
    },
    responseType: 'json',
});
exports.Http = Http;
const HttpNoAuth = axios_1.default.create({
    baseURL: '/api',
    withCredentials: false,
    headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
    },
    responseType: 'json',
});
if (token) {
    Http.defaults.headers.common['Auth-Token'] = token;
}
// Http.interceptors.request.use(
//     (r) =>
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
// eslint-disable-next-line no-param-reassign
// r.url = r.url.replace('/', `/${version}/`)
//         r,
// )
const handleApiErrors = (e) => new Promise((resolve, reject) => {
    const response = e.response || e;
    if (response && [401].includes(response.status)) {
        reject(response.data.errors);
        if (document?.cookie) {
            clearUserSession();
            window.location.pathname = '/';
        }
    }
    else if (response && [400, 403].includes(response.status)) {
        reject(response.data.errors);
    }
    else if (response &&
        [404].includes(response.status) &&
        ['carrier/v1/service/referral', 'warehouse/v1/service/referral'].includes(response.config.url)) {
        reject(response);
    }
    else {
        reject(response);
        // EventBus.$emit('error', {
        //     code: e.response.Status,
        //     title: 'Error ' + e.response.Status,
        //     message: e.response.data.errors,
        // })
    }
});
Http.interceptors.response.use((r) => {
    if (r.config.responseType === 'arraybuffer')
        return r;
    return r.data.data;
}, handleApiErrors);
HttpNoAuth.interceptors.response.use((r) => r.data.data, handleApiErrors);
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const getFetcher = (url, params) => {
    if (useMock) {
        return Mock_1.Mock.get(url, params);
    }
    return Http.get(url, { params }).then((res) => res);
};
exports.getFetcher = getFetcher;
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const getPublicFetcher = (url, params) => {
    if (useMock) {
        return Mock_1.Mock.get(url, params);
    }
    return HttpNoAuth.get(url, { params }).then((res) => res);
};
exports.getPublicFetcher = getPublicFetcher;
const clearUserSession = () => {
    if (localStorage) {
        localStorage.clear();
    }
    (0, utils_1.deleteAllCookies)();
};
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const postFetcher = (url, params) => Http.post(url, { params }).then((res) => res);
exports.postFetcher = postFetcher;
const swrConfiguration = {
    shouldRetryOnError: false,
    revalidateOnFocus: false,
};
exports.swrConfiguration = swrConfiguration;
